import React, { useEffect, useState } from 'react'
import { useMediaQuery } from 'react-responsive';
import { useHistory } from "react-router-dom";
import queryStringParse from "../../functions/queryParam";
import Search from "../modules/SearchPage/pages/Search";

function SearchPage(props) {

  const history = useHistory();
  const [params, setParams] = useState();
  const isMobile = useMediaQuery({ query: `(max-width: 760px)` });
  const isTabletOrMobile = useMediaQuery({ maxWidth: 991 });
  useEffect(() => {
    if (props.location.search) {
      const search = props.location.search // e.g: ?date=2022-09-06&count=1,0
      setParams(queryStringParse(search));

      let search_date = getDate(queryStringParse(search).date)
      let today = getDate()

      if (search_date < today) { // کنترل اینکه به هر دلیلی تاریخ قدیم سرچ شود
        var tomorrow = tomorrowDate();
        const search = `?date=${tomorrow}&count=1,0`
        setParams(queryStringParse(search));
        history.push(
          `/bus-ticket/${props.match.params.source_id}/${props.match.params.dest_id}?date=${tomorrow}&count=1,0`
        );
      }

    } else {
      var tomorrow = tomorrowDate();
      const search = `?date=${tomorrow}&count=1,0`
      setParams(queryStringParse(search));
      history.push(
        `/bus-ticket/${props.match.params.source_id}/${props.match.params.dest_id}?date=${tomorrow}&count=1,0`
      );
    }

  }, []);

  const tomorrowDate = () => {
    var currentDate = new Date(new Date().getTime() + 24 * 60 * 60 * 1000);
    var day = fixDate(currentDate.getDate()) // convert 7 => 07
    var month = fixDate(currentDate.getMonth() + 1)
    var year = currentDate.getFullYear()
    const tomorrowDate = `${year}-${month}-${day}`;
    return tomorrowDate;
  }

  const fixDate = (number) => {
    let num;
    try {
      if (number && number < 10) {
        num = `0${number}`;
        return `0${number}`
      } else {
        return number;
      }
    } catch (error) {
      console.log("error in fixDate", number, error)
      return number;
    }
  }

  const getDate = (date) => {
    try {
      return date ? new Date(date).toISOString().slice(0, 10) : new Date().toISOString().slice(0, 10)
    } catch (error) {
      console.log(error)
      return date;
    }
  }

  return (
    <>
      {params?.date && params.count ? (
        <Search
          date={params.date ? params.date : null}
          count={params.count}
          date2={null}
          source_id={props.match.params.source_id}
          dest_id={props.match.params.dest_id}
        />
      ) : null}
    </>
  )
}

export default SearchPage